import { Flex, useStyles } from '@archipro-design/aria';

import FilterBarFilters from '@modules/search/components/search-filter-section/FilterBarFilters';

import * as S from './CategoryFilterSection.style';

import type { OptionResult } from '@modules/search/components/search-filter-section/RoccoBasedSearchSort';
import SearchSort from '@modules/search/components/search-filter-section/RoccoBasedSearchSort';
import { useSearchSortOptions } from '~/modules/search/hook/use-search-sort-options';

import type { CategoryFilterSectionProps } from './CategoryFilterSection';

export const CategoryFilterSection = ({
    category,
    componentBefore,
    componentBarAddon,
    searchFilters,
}: CategoryFilterSectionProps) => {
    const { css } = useStyles();

    const { filterBarFilters, updateFilter, filterStates } = searchFilters;

    const optionResult = useSearchSortOptions({ category });

    return (
        <div className={css(S.FilterSectionWrapper)}>
            <Flex space="between" vAlign="center">
                {componentBefore}
                <Flex column gap="space-16">
                    <Flex
                        vAlign="center"
                        gap="space-16"
                        hAlign="end"
                        className={css(S.FilterActionContainer)}
                    >
                        {(componentBarAddon ||
                            (filterBarFilters &&
                                filterBarFilters.length > 0)) && (
                            <FilterBarFilters
                                filters={filterBarFilters ?? []}
                                updateFilter={updateFilter}
                                componentBarAddon={componentBarAddon}
                                filterStates={filterStates}
                            />
                        )}

                        {optionResult.items.length > 0 && (
                            <SearchSort
                                optionResult={optionResult as OptionResult}
                            />
                        )}
                    </Flex>
                </Flex>
            </Flex>
        </div>
    );
};
